module.exports = "<div id=\"compareDateTable{{widgetId}}\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/comparedate-table/comparedate-table.component.html
// module id = ../../../../../src/app/shared/components/graphs/comparedate-table/comparedate-table.component.html
// module chunks = main